import React, { useEffect } from 'react';
import { TopBanner, Nav, Footer, SUPPORT_EMAIL, APP_NAME } from './SiteChrome';
import './site.css';

// Published Child Sexual Abuse and Exploitation (CSAE) standards — required by
// Google Play for dating and social apps.
export default function ChildSafety() {
  useEffect(() => { document.title = 'Child Safety Standards — SparkSync'; }, []);
  return (
    <div className="site">
      <TopBanner />
      <Nav />
      <div className="wrap legal">
        <h1>Child Safety <span className="grad-text">Standards</span></h1>
        <p className="updated">Last updated: 6 October 2026</p>

        <p>
          {APP_NAME} has zero tolerance for child sexual abuse and exploitation (CSAE), including child
          sexual abuse material (CSAM). These standards explain what we prohibit, how we prevent and
          detect abuse, and how anyone can report a concern.
        </p>

        <h2>1. Adults only</h2>
        <p>
          {APP_NAME} is strictly for people aged 18 and over. Every user must confirm their date of birth
          when signing up, and accounts that appear to belong to a minor are suspended and removed.
        </p>

        <h2>2. What is prohibited</h2>
        <ul>
          <li>Creating, sharing, requesting or linking to child sexual abuse material of any kind, including drawn, edited or AI-generated content.</li>
          <li>Grooming, or any attempt to contact, befriend or meet a minor for sexual purposes.</li>
          <li>Sexualising minors in photos, profile text, messages or calls.</li>
          <li>Sextortion, trafficking, or any other exploitation of a child.</li>
          <li>Using {APP_NAME} if you are under 18, or helping someone under 18 to use it.</li>
        </ul>

        <h2>3. How we prevent and detect abuse</h2>
        <ul>
          <li>Age confirmation at sign-up, and phone or email verification for every account.</li>
          <li>Review of profiles and photos, with verified-profile badges for confirmed users.</li>
          <li>Moderation of content and accounts that users report to us.</li>
          <li>Blocking tools so users can immediately stop any contact.</li>
        </ul>

        <h2>4. How to report a concern</h2>
        <p>If you believe a child is in immediate danger, contact your local police first (in India, dial 112).</p>
        <ul>
          <li><b>In the app:</b> open <b>Profile → Help &amp; Support</b> and send us a report, and use <b>Block</b> from the chat menu to stop contact.</li>
          <li><b>By email:</b> write to <a className="grad-text" href={`mailto:${SUPPORT_EMAIL}?subject=Child%20safety%20report`}>{SUPPORT_EMAIL}</a> with “Child safety report” in the subject. Include the profile name and any details you can, but please do not send us images of abuse.</li>
        </ul>
        <p>Child safety reports are given priority and reviewed as quickly as possible.</p>

        <h2>5. What we do when abuse is reported</h2>
        <ul>
          <li>We remove the content and suspend the account involved, and permanently ban confirmed offenders.</li>
          <li>We preserve relevant information as required by law to support investigations.</li>
          <li>
            We report child sexual abuse material and exploitation to the relevant authorities, including
            the National Cybercrime Reporting Portal (cybercrime.gov.in) in India and the National Center
            for Missing &amp; Exploited Children (NCMEC), and we cooperate with law enforcement.
          </li>
        </ul>

        <h2>6. Compliance with child safety laws</h2>
        <p>
          {APP_NAME} complies with applicable child safety laws, including India’s Protection of Children
          from Sexual Offences (POCSO) Act, 2012 and the Information Technology Act, 2000, as well as the
          laws of other countries where the app is available.
        </p>

        <h2>7. Child safety contact</h2>
        <p>
          Our designated child safety point of contact can be reached at{' '}
          <a className="grad-text" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>. This contact is
          able to speak to our CSAM prevention practices and compliance.
        </p>
      </div>
      <Footer />
    </div>
  );
}
